export class BackgroundLayer {
  constructor(image, speed, color) {
    this.image = image;
    this.speed = speed;
    this.x = 0;
    this.color = color; // Fallback color if image not loaded
  }

  update() {
    this.x -= this.speed;
    if (this.x <= -800) {
      this.x = 0;
    }
  }

  draw(ctx, width, height) {
    if (this.image && this.image.complete && this.image.width > 0) {
      // Draw tiled background with transparency
      ctx.globalAlpha = 0.6; // Semi-transparent for depth
      ctx.drawImage(this.image, this.x, 0, width, height);
      ctx.drawImage(this.image, this.x + width, 0, width, height);
      ctx.globalAlpha = 1.0; // Reset alpha
    }
    // No fallback drawing - let the base gradient show through
  }
}

